import React from 'react';
import { IoIosRemove } from 'react-icons/io';
import styles from './styles/BotaoAdicionarVinculos.module.css';
import { MdAdd } from 'react-icons/md';

export default function BotaoAdicionarVinculos({ onClick, adicionar }) {
    const handleClick = (e) => {
        // Impede que o evento se propague para evitar problemas com eventos de clique aninhados
        e.stopPropagation();
        
        // Chama a função de callback com o evento
        if (onClick) {
            onClick(e);
        }
    };
    
    return (
        <button
            className={
                styles.botaoAdicionar + ' ' + (adicionar ? styles.adicionar : styles.remover)
            }
            onClick={handleClick}
            type="button"
        >
            <span className={styles.iconeMais}>{adicionar ? <MdAdd /> : <IoIosRemove />}</span>
        </button>
    );
}
